import { useMemo } from 'react'

import { useStarEffectSkins } from '@store'

export const useStars = () => {
  const stars = useStarEffectSkins()

  const sortedStars = useMemo(() => {
    return stars.sort((a) => (a.isAvailable ? -1 : 1))
  }, [stars])

  return { stars: sortedStars }
}
